module.exports = __webpack_public_path__ + "static/media/BodoniFLF-Roman.a5c77dca.ttf";